// extracted by mini-css-extract-plugin
export default {"logo":"PayPalCheckout--logo--PMST3"};